import { computed, Injectable, signal } from '@angular/core';
import { BreadcrumbInterface } from '../types/breadcrumb.interface';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  // breadcrumbs dinamici
  private dynamicCrumbs = signal<BreadcrumbInterface[]>([]);
  // breadcrumbs dal componente
  private manualCrumbs = signal<BreadcrumbInterface[]>([]);

  // final breadcrumbs
  public finalCrumbs = computed(() => {
    const m = this.manualCrumbs();
    return this.dynamicCrumbs() && this.dynamicCrumbs().length > 0
      ? this.dynamicCrumbs()
      : m;
  });

  constructor(private router: Router, private route: ActivatedRoute) {
    // build breadcrumb per static routes ssg
    this.dynamicCrumbs.set(this.buildBreadcrumb(this.route.root));

    // subscribe to router events
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.dynamicCrumbs.set(this.buildBreadcrumb(this.route.root));
      });
  }

  // Set manual breadcrumbs
  setManualBreadcrumbs(list: BreadcrumbInterface[]) {
    this.manualCrumbs.set(list);
  }

  // Reset manual breadcrumbs
  clearManualBreadcrumbs() {
    this.manualCrumbs.set([]);
  }

  // Build breadcrumb
  buildBreadcrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: BreadcrumbInterface[] = []
  ): BreadcrumbInterface[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL === '' || routeURL === 'home') {
        this.clearManualBreadcrumbs();
      }
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      let label = child.snapshot.data['breadcrumb'];

      if (label) {
        breadcrumbs.push({
          label,
          url,
        });
      }

      return this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
